<template>
    <!-- TODO css -->
    <modal @close="modals.campaignIntegrationsModal = false" :width="1000">
        <h3>{{ item.name }} <span>CRM Integration</span></h3>
        <div class="large-form">
            <div class="form-line">
                <div class="form-field" style="width: 100%">
                    <label for="form-input-name">
                        HubSpot Trigger Webhook
                        <div class="field-enabled-checkbox">
                            <input v-model="integrations.hubspot.webhook" type="checkbox"> <span class="checkbox-label">Enabled</span>
                        </div>
                    </label>
                    <div class="copy-url" :class="integrations.hubspot.webhook?'':'disabled'">
    					<a class="copy-url-url disabled" :href="urls.hubspot.webhook">{{ urls.hubspot.webhook }}</a>
    					<div @click="copyToClipboard(urls.hubspot.webhook)" class="ws-button ws-button-small">Copy URL</div>
    				</div>
                    <div class="field-note">Copy this URL and insert it into your HubSpot workflow as a new <i>Send A Webhook</i> action after your required trigger.</div>
                </div>
            </div>
            <div class="form-line">
                <div class="form-field" style="width: 100%">
                    <label for="form-input-name">
                        HubSpot Multiple Use Link
                        <div class="field-enabled-checkbox">
                            <input v-model="integrations.hubspot.multilink" type="checkbox"> <span class="checkbox-label">Enabled</span>
                        </div>
                    </label>
                    <div class="copy-url" :class="integrations.hubspot.multilink?'':'disabled'">
    					<a class="copy-url-url disabled" :href="urls.hubspot.multilink">{{ urls.hubspot.multilink }}</a>
    					<div @click="copyToClipboard(urls.hubspot.multilink)" class="ws-button ws-button-small">Copy URL</div>
    				</div>
                    <div class="field-note">You can include this multiple use link in your campaign emails on HubSpot and it will automatically create a gift claim link for each recipient.</div>
                </div>
            </div>
        </div>
        <div class="form-actions">
          <span class="ws-button ws-button-secondary" data-action="cancel" @click="modals.campaignIntegrationsModal = false">CANCEL</span>
          <span class="ws-button ws-button-main" data-action="start-campaign-confirm" @click="updateCampaign">UPDATE SETTINGS</span>
        </div>
    </modal>
</template>

<script>
import Modal from "@/components/modals/Modal";

export default {
    name: "GiftBoxCampaignsIntegrationsModal",
    components: {Modal},
    props: {
        itemId: Number,
        fetchItem: {type: Boolean, default: false},
    },
    data() {
        return {
            integrations: {
                hubspot: {webhook: false, multilink: false},
            },
            urls: {
                hubspot: {webhook: '', multilink: ''},
            }
        }
    },
    methods: {
        async updateCampaign() {
            if (!this.demoCheck()) return;
            
            await this.dispatchWaitAndNotify('updateGiftBoxCampaign', {campaignId: this.item.id, payload: {integrations: this.integrations}});
            this.$emit('updated');
        },
        copyToClipboard(text) {
			const el = document.createElement('textarea');
			el.value = text;
			el.setAttribute('readonly', '');
			el.style.position = 'absolute';
			el.style.left = '-9999px';
			document.body.appendChild(el);
			el.select();
			document.execCommand('copy');
			document.body.removeChild(el);
			this.notifyStatus(200, 'Link Copied', 'The link has been copied to your clipboard.');
		},
    },
    async mounted() {
        if (Object.keys(this.item.integrations).length) this.integrations = this.item.integrations;
        
        this.urls.hubspot.multilink = this.item.registration_page + '?i=hubspot&e={{contact.email}}';
        this.urls.hubspot.webhook = 'https://api.hub.bookblock.com/campaigns/' + this.item.id + '/trigger'; 
    },
    computed: {
        team() {
            return this.$store.state.team.detail;
        },
        item() {
            return this.$store.state.giftBoxCampaign.detail;
        },
        modals() {
            return this.$store.state.modals;
        },
        gbPageUrlBase() {
            return this.$store.state.gbPageUrlBase;
        }
    }
}
</script>

<style scoped>

</style>